import { useMemo } from 'react'
import get from 'lodash-es/get'

import { FormattedMessage, useIntl } from 'react-intl'

import { SelectDefault, SelectOption } from '@/lib/core/components/Select'
import {
  FieldError,
  FieldErrorMessage,
  Label,
} from '@/lib/core/components/TextField/TextField.styles'

import { useAssetFormState } from '@/lib/features/Assets/components/AddAssetModal/store/useAssetFormState'
import {
  AssetTypeOptions,
  AssetTypeValues,
} from '@/lib/features/Assets/components/AddAssetModal/constants'
import { FormType } from '@/lib/features/Assets/components/AddAssetModal/interfaces'
import messages from '@/lib/features/Assets/components/AddAssetModal/AddAssetModal.messages'

export type SelectTypeControlProps = {
  disabled?: boolean
  error?: string
}

export const SelectTypeControl = ({ disabled, error }: SelectTypeControlProps) => {
  const { formatMessage } = useIntl()
  const defaultValue = useAssetFormState((v) => v.selectedOption)
  const setAssetFormSelectedOption = useAssetFormState((v) => v.setSelectedOption)
  const setAssetFormType = useAssetFormState((v) => v.setType)

  const options = useMemo(
    () =>
      AssetTypeOptions.map(({ translationKey, value }) => ({
        label: formatMessage(get(messages, translationKey)),
        value,
      })),
    [],
  )

  const onChange = (option: SelectOption) => {
    setAssetFormSelectedOption(option)

    if (option.value === AssetTypeValues.PTU) {
      setAssetFormType(FormType.PTU)
    }

    if (option.value === AssetTypeValues.VEHICLE) {
      setAssetFormType(FormType.VEHICLE_BASIC)
    }
  }

  return (
    <>
      <Label $disabled={disabled} $displayInline $required htmlFor="assetType">
        <FormattedMessage {...messages.whatTrack} />
      </Label>
      <SelectDefault
        aria-labelledby="assetType"
        id="add-asset-form-asset"
        name="assetType"
        isSearchable={false}
        isDisabled={disabled}
        defaultValue={defaultValue}
        // @ts-expect-error Not sure how this was setup originally but it's working
        onChange={onChange}
        options={options}
        placeholder={formatMessage(messages.select)}
      />
      <FieldError>
        {error && <FieldErrorMessage $displayInline>{error}</FieldErrorMessage>}
      </FieldError>
    </>
  )
}
